import { HabitsData, HabitsState, HabitsMainItem, HabitsBeneficioItem } from '../types/habits.types'
import normalizeText from './normalizeText'

export const habitsTransformers = {
	/**
	 * Distribución interna de datos para filtros específicos
	 */
	internalDistribution: ({
		internalData,
		key
	}: {
		internalData: HabitsBeneficioItem[]
		key: string
	}): HabitsBeneficioItem[] => {
		if (!internalData || !Array.isArray(internalData)) {
			return []
		}

		const all = internalData.flatMap(
			e => e.beneficioCollection?.items?.map(j => ({ ...j, idFather: e.idReto })) || []
		)

		if (key.includes('reto')) {
			const dataChallenge = internalData.map(e => ({
				...e,
				beneficioCollection: {
					items: e.beneficioCollection?.items?.map(j => ({ ...j, idFather: e.idReto })) || []
				}
			}))
			return dataChallenge
		}

		if (key.includes('all')) {
			return all
		}

		return all
			? all.filter(j => (j.comunidad ? normalizeText(j.comunidad[0]).includes(key) : false))
			: []
	},

	/**
	 * Distribución principal de datos de hábitos
	 */
	distributionData: (currentData: HabitsMainItem[]): HabitsState => {
		if (!currentData || !Array.isArray(currentData)) {
			return {
				allianceData: false,
				dimensionData: false,
				allHabitsDays: false
			}
		}

		const allianceFilter = currentData.filter(e => e?.idReto === 'aliados')

		let habitData: Record<string, HabitsMainItem> = {}

		currentData.forEach(e => {
			if (e.idReto !== 'aliados') {
				const filters = [...(e?.comunidad || []), 'all']
				habitData = {
					...habitData,
					[normalizeText(e?.idReto).replace(/-/g, '')]: {
						...e,
						tabs: filters.reduce(
							(acc, curr) => ({
								...acc,
								[normalizeText(curr)]: habitsTransformers.internalDistribution({
									internalData: e?.beneficioCollection?.items || [],
									key: normalizeText(curr)
								})
							}),
							{}
						)
					}
				}
			}
		})

		const allHabits = Object.values(currentData)
			.flatMap(e => [...(e?.beneficioCollection?.items || [])])
			.flatMap(e => [...(e?.beneficioCollection?.items || [])])

		return {
			allianceData: allianceFilter.length > 0 ? allianceFilter : false,
			dimensionData: Object.keys(habitData).length > 0 ? habitData : false,
			allHabitsDays: allHabits.length > 0 ? allHabits : false
		}
	},

	/**
	 * Transformar datos raw de Contentful a estado de hábitos
	 */
	transformHabitsData: (data: HabitsData): HabitsState => {
		try {
			const habitsItems =
				data?.homeCollection?.items?.[0]?.vistas?.habitos?.beneficioCollection?.items

			if (!habitsItems) {
				console.warn('⚠️ No se encontraron datos de hábitos en la respuesta')
				return {
					allianceData: false,
					dimensionData: false,
					allHabitsDays: false
				}
			}

			return habitsTransformers.distributionData(habitsItems)
		} catch (error) {
			console.error('❌ Error transformando datos de hábitos:', error)
			return {
				allianceData: false,
				dimensionData: false,
				allHabitsDays: false
			}
		}
	}
}
